import apiClient from './apiClient';
import AuthService from '../../modules/Admin/services/AuthService';

const CACHE_KEY = 'nf_tenant_industry_v2';

export function clearTenantIndustryCache() {
  try {
    sessionStorage.removeItem(CACHE_KEY);
    sessionStorage.removeItem('nf_tenant_industry_v1');
  } catch {
    /* ignore */
  }
}

export async function fetchTenantIndustry(clientId) {
  if (!clientId) return { agencyCategoryId: null, agencyCategoryName: '' };

  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached) {
      const parsed = JSON.parse(cached);
      if (parsed?.clientId === String(clientId) && parsed.agencyCategoryId != null) return parsed;
    }
  } catch {
    /* ignore */
  }

  const res = await apiClient.get(`/Client/GetAgencyLogoAndNameByClientId/${clientId}`);
  const data = res.data ?? {};
  const categoryId = data.agencyCategoryId ?? data.AgencyCategoryId;
  const info = {
    clientId: String(clientId),
    agencyCategoryId: categoryId != null && categoryId !== '' ? String(categoryId) : null,
    agencyCategoryName: data.agencyCategoryName ?? data.AgencyCategoryName ?? '',
  };
  sessionStorage.setItem(CACHE_KEY, JSON.stringify(info));
  return info;
}
